import { Directive, OnInit, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  standalone: false,
  // selector: '[tooltipTitle]'
  selector:
    'input[formControlName], input[formControl], select[formControlName], select[formControl], mat-select[formControlName], mat-select[formControl], mat-list-option'
})
export class TooltipTitleDirective implements OnInit {
  constructor(public el: ElementRef, public ngControl: NgControl) {}
  ngOnInit() {
    setTimeout(() => {
      if (!this.el.nativeElement.title) {
        this.setTitle();
        // this.ngControl.control.valueChanges.subscribe(() => {
        //   this.setTitle();
        // });
      }
    });
  }
  setTitle() {
    setTimeout(() => {
      if (this.el.nativeElement.innerText || this.el.nativeElement.value) {
        this.el.nativeElement.title =
          this.el.nativeElement.innerText || this.el.nativeElement.value;
        this.el.nativeElement.setAttribute('data-toggle', 'tooltip');
      }
    });
  }
}
